// Copyright 2006-2011 David Caldwell <david@greenfelt.net>, Jim Radford <jim@greenfelt.net>  All rights reserved.

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile, in_order_by=piles.in_order_by, ace=piles.ace,
                              in_suit_order=piles.in_suit_order, drag_max_given_free=piles.drag_max_given_free, king=piles.king, up=piles.up, down=piles.down,
                              in_off_color_order=piles.in_off_color_order, in_different_suit_order=piles.in_different_suit_order,
                              generic_foundation=piles.generic_foundation;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var seed_game = require('./seed_game'), WON=seed_game.WON, NOT_COMPLETE=seed_game.NOT_COMPLETE;
var options = require('./options'), option_def=options.option_def;

solitaire.fortythieves = class extends pile_game {
    constructor(variant) {
        super();
        this.init_options(variant);
        if (this.options.fan_out_waste)
            this.layout = this.fan_out_layout;
        this.pile_game_init(...arguments);
        this.decks = 2;
        this.foundation = [];
        for (var i=1; i<=8; i++)
            this.foundation.push(new generic_foundation("good"+i, this));
        this.tableau = [];
        for (var i=1; i<=this.options.columns; i++)
            this.tableau.push(new this.tableau_pile("tableau"+i, this));

        this.stock = new pile("stock", this);
        this.waste = new pile("waste", this);
        this.create_deck(this.stock, this.waste, 1, this.options.redeals);
        this.stock.maxstack = 52*2-40;
        this.stock.xoffset = .3/90;
        this.stock.yoffset = .3/131;
        if (this.options.fan_out_waste) {
            this.waste.xoffset = 12/90;
            delete this.waste.coords; // Use standard coords, so the fan works correctly.
            delete this.waste.splice; // get rid of possible webkit splice_and_turn_under
        }
    }
    static variants = { napolean: { alias: "fortythieves" },
                    limited:     { rows: 3, columns: 12 },
                    lucas:       { rows: 3, columns: 13, aces_in_foundations: true },
                    maria:       { rows: 4, columns:  9, off_color_tableau: true },
                    streets:     { off_color_tableau: true },
                    numberten:   { rows: 4, face_down_rows: 2, off_color_tableau: true, drag_sequences: true },
                    rankandfile: { rows: 4, face_down_rows: 3, off_color_tableau: true, drag_sequences: true },
                    dressparade: { alias: "rankandfile" },
                    indian:      { rows: 3, face_down_rows: 1, different_suit_tableau: true },
                    fortyandeight:{ rows: 5, columns: 8, redeals: 1, fan_out_waste: true } };

    valid_options = { columns:                option_def("number",     10, "Piles in tableau"),
                         rows:                   option_def("number",      4, "Face up cards dealt to tableau piles"),
                         face_down_rows:         option_def("number",      0, "Face down cards dealt to tableau piles"),
                         aces_in_foundations:    option_def("boolean", false, "Aces are removed from deck before game and put into foundations"),
                         off_color_tableau:      option_def("boolean", false, "Cards on tableau are built down in off color order"),
                         different_suit_tableau: option_def("boolean", false, "Cards on tableau are built down in different suit order"),
                         drag_sequences:         option_def("boolean", false, "Able to drag tableau sequences instead of single cards"),
                         fan_out_waste:          option_def("boolean", false, "Fan out the waste pile so you can see all the cards"),
                         redeals:                option_def("number",      0, "Number of redeals")
                    };


    tableau_pile = class extends pile {
        constructor(div,game) {
                super(div,game);
                if (this.game.options.off_color_tableau)      this.drag_order = in_off_color_order;
                if (this.game.options.different_suit_tableau) this.drag_order = in_different_suit_order;
        }
        accept_stacks = true;
        accept(cards) { return  this.pile.length == 0 && (this.game.options.drag_sequences ||
                                                                            cards.length <= drag_max_given_free(this.game.tableau, this)) ? 1
                                                : this.pile.length != 0 && this.drag_order(cards[0],this.top()) ? 3 : 0; };
        drag_order = in_suit_order;
        can_drag(index) { return in_order_by(this.drag_order, this.pile, index)
                                 && (this.game.options.drag_sequences || this.pile.length - index <= drag_max_given_free(this.game.tableau)); }
        xoffset = 0;
        splice = super.splice_and_turn_over;
        maxstack = Math.ceil(7.34809160305343); // Determined by query in upgrades/maxstack.sql
    }

    deal(deck) {
            if (this.options.aces_in_foundations)
                for (var c=0; c<deck.length; c++)
                    if (deck[c].rank == ace) {
                        deck[c].face = up;
                        var best_foundation = { rank:0 }, rank;
                        for (var f=0; f<this.foundation.length; f++)
                            if (Math.max(best_foundation.rank, rank=this.foundation[f].accept([deck[c]])) > best_foundation.rank)
                                best_foundation = { rank: rank, f: f };
                        this.foundation[best_foundation.f].push(deck[c]);
                    } else
                        this.stock.push(deck[c]);
            else
                this.stock.pile = deck;
            for (var r=0; r<this.options.rows; r++)
                for (var c=0; c<this.options.columns; c++) {
                    var card;
                    this.tableau[c].push(card = this.stock.pop());
                    card.face = r >= this.options.face_down_rows ? up : down;
                }
    }

    is_complete() {
            for (var i in this.foundation)
                if (this.foundation[i].pile.length == 0 || this.foundation[i].top().rank != king)
                    return NOT_COMPLETE;
            return WON;
    }

    score() {
            return this.count_cards_in(this.foundation);
    }

    complete() {
            return this.complete_generic(this.foundation, [this.tableau, [this.waste]]);
    }

    layout = grid(["stock", { x: +.25 }, "waste", {x: +.15}, "good1", "good2", "good3", "good4", "good5", "good6", "good7", "good8"],
                  [{ x: +.40, y: +.15},
                   "tableau1", "tableau2", "tableau3", "tableau4", "tableau5", "tableau6", "tableau7", "tableau8", "tableau9", "tableau10"]);

    fan_out_layout = grid([void 0, "good1", "good2", "good3", "good4", "good5", "good6", "good7", "good8"],
                          ["stock", { x: +.25 }, "waste"],
                          [{ y: +.15},
                           "tableau1", "tableau2", "tableau3", "tableau4", "tableau5", "tableau6", "tableau7", "tableau8", "tableau9", "tableau10", "tableau11", "tableau12", "tableau13"]);
}

module.exports = solitaire.fortythieves;
// Copyright 2006-2011 David Caldwell <david@greenfelt.net>, Jim Radford <jim@greenfelt.net>  All rights reserved.

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile, in_order_by=piles.in_order_by, ace=piles.ace,
                              in_suit_order=piles.in_suit_order, drag_max_given_free=piles.drag_max_given_free, king=piles.king, up=piles.up, down=piles.down,
                              in_off_color_order=piles.in_off_color_order, in_different_suit_order=piles.in_different_suit_order,
                              generic_foundation=piles.generic_foundation;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var seed_game = require('./seed_game'), WON=seed_game.WON, NOT_COMPLETE=seed_game.NOT_COMPLETE;
var options = require('./options'), option_def=options.option_def;

solitaire.fortythieves = class extends pile_game {
    constructor(variant) {
        super();
        this.init_options(variant);
        if (this.options.fan_out_waste)
            this.layout = this.fan_out_layout;
        this.pile_game_init(...arguments);
        this.decks = 2;
        this.foundation = [];
        for (var i=1; i<=8; i++)
            this.foundation.push(new generic_foundation("good"+i, this));
        this.tableau = [];
        for (var i=1; i<=this.options.columns; i++)
            this.tableau.push(new this.tableau_pile("tableau"+i, this));

        this.stock = new pile("stock", this);
        this.waste = new pile("waste", this);
        this.create_deck(this.stock, this.waste, 1, this.options.redeals);
        this.stock.maxstack = 52*2-40;
        this.stock.xoffset = .3/90;
        this.stock.yoffset = .3/131;
        if (this.options.fan_out_waste) {
            this.waste.xoffset = 12/90;
            delete this.waste.coords; // Use standard coords, so the fan works correctly.
            delete this.waste.splice; // get rid of possible webkit splice_and_turn_under
        }
    }
    static variants = { napolean: { alias: "fortythieves" },
                    limited:     { rows: 3, columns: 12 },
                    lucas:       { rows: 3, columns: 13, aces_in_foundations: true },
                    maria:       { rows: 4, columns:  9, off_color_tableau: true },
                    streets:     { off_color_tableau: true },
                    numberten:   { rows: 4, face_down_rows: 2, off_color_tableau: true, drag_sequences: true },
                    rankandfile: { rows: 4, face_down_rows: 3, off_color_tableau: true, drag_sequences: true },
                    dressparade: { alias: "rankandfile" },
                    indian:      { rows: 3, face_down_rows: 1, different_suit_tableau: true },
                    fortyandeight:{ rows: 5, columns: 8, redeals: 1, fan_out_waste: true } };

    valid_options = { columns:                option_def("number",     10, "Piles in tableau"),
                         rows:                   option_def("number",      4, "Face up cards dealt to tableau piles"),
                         face_down_rows:         option_def("number",      0, "Face down cards dealt to tableau piles"),
                         aces_in_foundations:    option_def("boolean", false, "Aces are removed from deck before game and put into foundations"),
                         off_color_tableau:      option_def("boolean", false, "Cards on tableau are built down in off color order"),
                         different_suit_tableau: option_def("boolean", false, "Cards on tableau are built down in different suit order"),
                         drag_sequences:         option_def("boolean", false, "Able to drag tableau sequences instead of single cards"),
                         fan_out_waste:          option_def("boolean", false, "Fan out the waste pile so you can see all the cards"),
                         redeals:                option_def("number",      0, "Number of redeals")
                    };


    tableau_pile = class extends pile {
        constructor(div,game) {
                super(div,game);
                if (this.game.options.off_color_tableau)      this.drag_order = in_off_color_order;
                if (this.game.options.different_suit_tableau) this.drag_order = in_different_suit_order;
        }
        accept_stacks = true;
        accept(cards) { return  this.pile.length == 0 && (this.game.options.drag_sequences ||
                                                                            cards.length <= drag_max_given_free(this.game.tableau, this)) ? 1
                                                : this.pile.length != 0 && this.drag_order(cards[0],this.top()) ? 3 : 0; };
        drag_order = in_suit_order;
        can_drag(index) { return in_order_by(this.drag_order, this.pile, index)
                                 && (this.game.options.drag_sequences || this.pile.length - index <= drag_max_given_free(this.game.tableau)); }
        xoffset = 0;
        splice = super.splice_and_turn_over;
        maxstack = Math.ceil(7.34809160305343); // Determined by query in upgrades/maxstack.sql
    }

    deal(deck) {
            if (this.options.aces_in_foundations)
                for (var c=0; c<deck.length; c++)
                    if (deck[c].rank == ace) {
                        deck[c].face = up;
                        var best_foundation = { rank:0 }, rank;
                        for (var f=0; f<this.foundation.length; f++)
                            if (Math.max(best_foundation.rank, rank=this.foundation[f].accept([deck[c]])) > best_foundation.rank)
                                best_foundation = { rank: rank, f: f };
                        this.foundation[best_foundation.f].push(deck[c]);
                    } else
                        this.stock.push(deck[c]);
            else
                this.stock.pile = deck;
            for (var r=0; r<this.options.rows; r++)
                for (var c=0; c<this.options.columns; c++) {
                    var card;
                    this.tableau[c].push(card = this.stock.pop());
                    card.face = r >= this.options.face_down_rows ? up : down;
                }
    }

    is_complete() {
            for (var i in this.foundation)
                if (this.foundation[i].pile.length == 0 || this.foundation[i].top().rank != king)
                    return NOT_COMPLETE;
            return WON;
    }

    score() {
            return this.count_cards_in(this.foundation);
    }

    complete() {
            return this.complete_generic(this.foundation, [this.tableau, [this.waste]]);
    }

    layout = grid(["stock", { x: +.25 }, "waste", {x: +.15}, "good1", "good2", "good3", "good4", "good5", "good6", "good7", "good8"],
                  [{ x: +.40, y: +.15},
                   "tableau1", "tableau2", "tableau3", "tableau4", "tableau5", "tableau6", "tableau7", "tableau8", "tableau9", "tableau10"]);

    fan_out_layout = grid([void 0, "good1", "good2", "good3", "good4", "good5", "good6", "good7", "good8"],
                          ["stock", { x: +.25 }, "waste"],
                          [{ y: +.15},
                           "tableau1", "tableau2", "tableau3", "tableau4", "tableau5", "tableau6", "tableau7", "tableau8", "tableau9", "tableau10", "tableau11", "tableau12", "tableau13"]);
}

module.exports = solitaire.fortythieves;
